import { makeStyles } from "@mui/styles";
import CommonStyles from "../CommonStyles";


const useStyles = makeStyles(() => ({
  wrapper:{
    fontWeight:400,
    fontFamily: "'DM Sans', sans-serif !important"
  }
  }))



const CustomFormLabel = ({labelName,isMandotary, classNames,fontSize = "14px"}:{labelName:any, isMandotary:boolean, classNames?:string, fontSize?:string})=>{
  const classes = useStyles();
  const classesCommon = CommonStyles();

return<>
<span style={{ fontSize: fontSize }} className={`${classNames} theme-form-label ${classesCommon.themeColorTxt} ${classes.wrapper}`}>
                      {labelName} {isMandotary && <span style={{ color: "red" }}>*</span>}
                    </span></>
}
export default CustomFormLabel ;